const HEIGHTS = [8, 14, 22, 12, 26, 18, 10, 24, 16, 20, 9, 25, 13, 21, 11, 19, 26, 12, 17, 23, 10, 15, 22, 9];

/** Animated voice waveform (decorative). `bars` ≤ 24; `scale` multiplies bar heights. */
export const Waveform = ({ bars = 24, scale = 1, className = '', barClassName = 'bg-logo-gradient', barWidth = 4 }) => (
  <div className={`flex items-center gap-[3px] ${className}`} aria-hidden="true">
    {HEIGHTS.slice(0, bars).map((h, i) => (
      <span
        key={i}
        className={`animate-wave rounded-full ${barClassName}`}
        style={{ width: barWidth, height: Math.round(h * scale), animationDelay: `${-(i % 7) * 0.15}s` }}
      />
    ))}
  </div>
);

export default Waveform;
